import React from 'react';
import { getTheme } from '../theme';
import { TEXTING_OFF_TITLE, TEXTING_OFF_BODY } from '../utils/texting';

// The one notice every texting surface shows when the shop has no texting set
// up. One wording, so staff learn it once.
export default function TextingOff({ theme, compact = false }) {
  const T = getTheme(theme);
  return (
    <div role="status" style={{
      border: `1px solid ${T.border}`, borderRadius: 8, padding: compact ? '10px 12px' : '14px 16px',
      background: T.card, color: T.text, fontFamily: "'Inter', sans-serif",
    }}>
      <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>{TEXTING_OFF_TITLE}</div>
      <div style={{ fontSize: 13, color: T.textSub, lineHeight: 1.45 }}>{TEXTING_OFF_BODY}</div>
    </div>
  );
}
